<template>
  <div class="poster">
    <div class="margin"></div>
    <div class="image"><img :src="'/images/design/' + poster.url" :alt=poster.caption :title=poster.caption></div>
    <div class="margin"><div class="caption"><p>{{ poster.caption }}</p></div></div>
  </div>
</template>

<script>
 export default{
  name:'poster-item',
  props: {
    poster: Object
  }
 }
</script>
